const SUCCESS_MESSAGE_TIME = 3000;
const NAV_DRAWER_WIDTH = 296;

const NAV_CLOSED_DRAWER_WIDTH = 64;
const ADDRESS_DRAWER_WIDTH = 320;
const XS_WIDTH = 0;
const SM_WIDTH = 640;
const MD_WIDTH = 1024;
const LG_WIDTH = 1200;
const XL_WIDTH = 1536;
/** Between sm and md — shell-style layout breakpoints (UIContext). */
const SMD_WIDTH = 900;
/** Min viewport width for “sidekick” product table layouts (shell parity). */
const TABLE_PRODUCTS_MIN_WIDTH = 1200;
const TABLE_CATEGORIES_MIN_WIDTH = 1200;
const TERMINALS_PER_PAGE = 2;
const ADDRESSES_PER_PAGE = 3;
const ADDRESSES_PER_LARGE_PAGE = 5;
const ANIMATION_MINIMUM_TIMEOUT = 1000;

export {
  SUCCESS_MESSAGE_TIME,
  NAV_DRAWER_WIDTH,
  NAV_CLOSED_DRAWER_WIDTH,
  ADDRESS_DRAWER_WIDTH,
  XS_WIDTH,
  SM_WIDTH,
  MD_WIDTH,
  LG_WIDTH,
  XL_WIDTH,
  SMD_WIDTH,
  TABLE_PRODUCTS_MIN_WIDTH,
  TABLE_CATEGORIES_MIN_WIDTH,
  TERMINALS_PER_PAGE,
  ADDRESSES_PER_PAGE,
  ADDRESSES_PER_LARGE_PAGE,
  ANIMATION_MINIMUM_TIMEOUT,
};
